export function getMessageStatusPresentation(message) {
  const direction = String(message?.direction || '').toLowerCase();
  const status = String(message?.status || '').trim().toLowerCase();

  if (direction !== 'outbound') {
    return { label: 'Recebida', icon: 'inbound', tone: 'neutral' };
  }

  if (message?.error_message || ['failed', 'error', 'undelivered'].includes(status)) {
    return { label: 'Falha no envio', icon: 'error', tone: 'error' };
  }

  if (['read', 'read_by_me', 'viewed', 'played'].includes(status)) {
    return { label: 'Lida', icon: 'double-check', tone: 'read' };
  }

  if (message?.sent_from_business_app && status === 'received') {
    return { label: 'Registrada do aplicativo empresarial', icon: 'clock', tone: 'neutral' };
  }

  if (['delivered', 'received'].includes(status)) {
    return { label: 'Entregue', icon: 'double-check', tone: 'delivered' };
  }

  if (['sent', 'server_ack'].includes(status)) {
    return { label: 'Enviada', icon: 'check', tone: 'sent' };
  }

  if (status === 'accepted') {
    return { label: 'Aceita para processamento', icon: 'clock', tone: 'pending' };
  }

  if (status === 'unknown') {
    return { label: 'Confirmação pendente — não reenviar', icon: 'clock', tone: 'pending' };
  }

  if (['pending', 'queued', 'processing'].includes(status)) {
    return { label: 'Processando', icon: 'clock', tone: 'pending' };
  }

  return { label: 'Status atualizado', icon: 'clock', tone: 'neutral' };
}

export function getMessageIdentityPresentation(message, contact) {
  const isOutbound = String(message?.direction || '').toLowerCase() === 'outbound';
  if (isOutbound) {
    return {
      isOutbound: true,
      primary: message?.instance_name || 'Canal oficial',
      secondary: message?.instance_phone_display || message?.instance_phone_normalized || '',
      sender: message?.sent_by_label
        || message?.sent_by_username
        || (message?.sent_by_me ? 'Aplicativo conectado' : 'Equipe'),
    };
  }

  const primary = contact?.name || contact?.phone_display || contact?.phone_normalized || 'Cliente';
  const phone = contact?.phone_display || contact?.phone_normalized || '';
  return {
    isOutbound: false,
    primary,
    secondary: phone && phone !== primary ? phone : '',
    sender: '',
  };
}

export function formatServiceWindowRemaining(expiresAt, now = Date.now()) {
  const remaining = new Date(expiresAt).getTime() - Number(now);
  if (!Number.isFinite(remaining) || remaining <= 0) return '';

  // A janela oficial e de 24 horas. O arredondamento deve acontecer antes de
  // separar horas e minutos para nunca produzir valores como "23h 60min".
  const totalMinutes = Math.min(24 * 60, Math.max(1, Math.ceil(remaining / 60000)));
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  if (hours > 0 && minutes > 0) return `${hours}h ${minutes}min`;
  if (hours > 0) return `${hours}h`;
  return `${minutes}min`;
}
